var _path, _path2, _path3, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSimpleinline = function SvgSimpleinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 130,
    height: 40,
    fill: "none",
    viewBox: "0 0 130 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#756EDA",
    d: "M51.152 25.827h4.098c.021.939.204 1.621.548 2.048.28.405.774.608 1.484.608.753 0 1.29-.235 1.613-.704.323-.448.484-1.12.484-2.016 0-.917-.15-1.61-.451-2.08-.301-.47-.914-.81-1.84-1.024l-.838-.224c-1.054-.299-1.86-.64-2.42-1.024-.645-.405-1.14-.896-1.484-1.472a5.67 5.67 0 0 1-.742-2.016c-.13-.725-.194-1.59-.194-2.592 0-2.07.517-3.627 1.549-4.672 1.033-1.024 2.527-1.536 4.485-1.536 1.914 0 3.355.48 4.323 1.44.99 1.003 1.527 2.613 1.613 4.832h-4.13c-.021-.875-.172-1.515-.452-1.92-.258-.384-.71-.576-1.354-.576-.624 0-1.087.192-1.388.576-.301.427-.451 1.035-.451 1.824 0 .47.032.864.096 1.184.022.299.119.565.29.8.151.213.366.395.646.544.258.15.624.288 1.097.416l.774.224c1.075.32 1.828.587 2.258.8.56.256 1.012.587 1.356.992.516.512.892 1.227 1.129 2.144.193.896.29 1.952.29 3.168 0 1.237-.14 2.272-.42 3.104-.3.896-.709 1.6-1.225 2.112-.58.576-1.226.97-1.936 1.184-.774.256-1.645.384-2.613.384-1.979 0-3.485-.544-4.517-1.632-1.054-1.045-1.613-2.677-1.678-4.896M70.117 32.13h-4.226V9.348h4.226V32.13M77.261 32.13h-3.968V9.348h3.968l3.84 12.448 3.838-12.448h3.937V32.13h-3.969V21.155l.065-2.336-.452 1.952-2.13 6.976h-2.58l-2.162-6.976-.451-1.952.064 2.336V32.13M91.977 32.13V9.348h6.356c1.935 0 3.441.522 4.516 1.568 1.097 1.066 1.646 2.784 1.646 5.152v.8c0 2.346-.538 4.053-1.613 5.12-1.054 1.045-2.571 1.568-4.55 1.568h-2.129v8.576h-4.226m5.936-18.975h-1.71v6.592h1.71c.882 0 1.495-.235 1.839-.704.344-.427.516-1.216.516-2.368v-.416c0-1.131-.172-1.931-.516-2.4-.344-.47-.957-.704-1.84-.704ZM117.626 32.13h-10.841V9.348h4.227v18.912h6.614v3.872M119.352 9.347h10.647v3.872h-6.421v5.504h5.421v3.84h-5.421v5.696h6.421v3.872h-10.647V9.347"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#simple_inline_svg__a)",
    d: "M29.76 20c0 5.375-4.362 9.733-9.742 9.733-5.38 0-9.74-4.358-9.74-9.733 0-5.375 4.36-9.732 9.74-9.732S29.76 14.625 29.76 20"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "simple_inline_svg__c",
    width: 41,
    height: 40,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#simple_inline_svg__b)",
    fillRule: "evenodd",
    d: "M20.017 5.094A14.93 14.93 0 0 0 9.468 9.46 14.906 14.906 0 0 0 5.098 20a14.894 14.894 0 0 0 4.37 10.54 14.92 14.92 0 0 0 10.55 4.366 14.93 14.93 0 0 0 10.548-4.366A14.904 14.904 0 0 0 34.936 20a14.893 14.893 0 0 0-4.37-10.54 14.92 14.92 0 0 0-10.549-4.366m-7.66-3.572a20.032 20.032 0 0 1 21.815 4.336A20 20 0 0 1 40.035 20a19.985 19.985 0 0 1-5.863 14.142A20.02 20.02 0 0 1 20.017 40a20.032 20.032 0 0 1-14.154-5.858A20 20 0 0 1 0 20 19.986 19.986 0 0 1 5.863 5.858a20.019 20.019 0 0 1 6.494-4.336",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#simple_inline_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#simple_inline_svg__d)",
    fillRule: "evenodd",
    d: "M31.049 9.965a14.92 14.92 0 0 0-5.111-3.646l2.023-4.676a20.016 20.016 0 0 1 11.092 12.172 19.983 19.983 0 0 1-1.804 16.363l-4.39-2.592a14.898 14.898 0 0 0-1.81-17.62",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#simple_inline_svg__e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#simple_inline_svg__f)",
    fillRule: "evenodd",
    d: "M21.99 5.225A14.93 14.93 0 0 0 10.956 8.16a14.909 14.909 0 0 0-5.726 9.87 14.893 14.893 0 0 0 2.936 11.024 14.915 14.915 0 0 0 4.37 3.843 2.546 2.546 0 0 1 .927 3.48 2.55 2.55 0 0 1-3.484.927 20.012 20.012 0 0 1-9.306-12.16A19.983 19.983 0 0 1 2.7 9.97 20.006 20.006 0 0 1 14.87.673a20.034 20.034 0 0 1 15.186 2.024 2.546 2.546 0 0 1 .927 3.481 2.55 2.55 0 0 1-3.484.926 14.928 14.928 0 0 0-5.509-1.879",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#simple_inline_svg__g)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#simple_inline_svg__h)",
    fillRule: "evenodd",
    d: "M23.911 34.39a14.917 14.917 0 0 0 8.958-6.819l4.392 2.588a20.015 20.015 0 0 1-12.02 9.148 20.033 20.033 0 0 1-14.994-1.852 2.546 2.546 0 0 1-.98-3.466 2.55 2.55 0 0 1 3.469-.98 14.93 14.93 0 0 0 11.175 1.38",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#simple_inline_svg__i)",
    fillRule: "evenodd",
    d: "M31.922 28.982a14.899 14.899 0 0 0 2.99-8.171l5.092.277A19.99 19.99 0 0 1 35.99 32.05l-4.07-3.07",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "simple_inline_svg__a",
    x1: 20.018,
    x2: 20.018,
    y1: 10.268,
    y2: 29.733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9D85F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A5EC7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "simple_inline_svg__b",
    x1: 20.017,
    x2: 20.017,
    y1: 0,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9D85F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A5EC7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "simple_inline_svg__d",
    x1: 32.986,
    x2: 32.986,
    y1: 1.643,
    y2: 30.178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#876DED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9480F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "simple_inline_svg__f",
    x1: 15.664,
    x2: 15.664,
    y1: 0,
    y2: 37.647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9D85F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A5EC7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "simple_inline_svg__h",
    x1: 23.616,
    x2: 23.102,
    y1: 27.64,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9D85F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7276E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "simple_inline_svg__i",
    x1: 35.464,
    x2: 33.944,
    y1: 20.434,
    y2: 30.434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E79ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9582F4"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "simple_inline_svg__e",
    width: 95.328,
    height: 101.647,
    x: -16,
    y: -20,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 16,
    dy: 12
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4275_10820"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4275_10820",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "simple_inline_svg__g",
    width: 60.32,
    height: 44.429,
    x: 4.941,
    y: 15.571,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 12,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4275_10820"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4275_10820",
    result: "shape"
  })))));
};
export default SvgSimpleinline;